module.exports = __webpack_public_path__ + "img/Gbs.fcb5e065.svg";